export default "__VITE_ASSET__DpgY57Zt__"